import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Results from './Results';
import { getSearchResults } from '../../actions/filterActions';
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom';

function SearchResults(props) {

    const {error, loading, searchResults} = useSelector(state => state.searchResults)

    const {keyword} = useParams()

    const navigate = useNavigate()

    const [val, setVal] = useState()

    useEffect(()=>{
        setVal(keyword)
        localStorage.setItem("path", `/search_results/${keyword}`)
        window.scrollTo(0, 0)
    },[keyword])

    if(props.userLoading){
        return (<div>Loading...</div>)
      } else {
        if(props.user){
      return (
        <>
            <Results
                data = {searchResults}
                title = {"SEARCH RESULTS"}
                loading = {loading}
                error = {error}
                setVideo = {props.setVideo}
                filterActive = {props.filterActive}
                setFilterActive = {props.setFilterActive}
                searchFunc = {getSearchResults}
                val = {val}
            />
        </>
    );
    } else {
        navigate('/login')
    }

}
}

export default SearchResults;